export default class Menu {

    constructor() {
        Menu.burger();
        Menu.scroll_header_large();
    }

    static burger() {
        const trigger           = '[data-trigger="wpiris-menu-toggle"]',
            $element          = $( '[data-id="wpiris-menu"]' ),
            elementItem       = '[data-id="wpiris-menu-item"]',
            elementItemParent = '[data-id="wpiris-menu-item"].withChildrens > a',
            triggerMore       = '[data-trigger="wpiris-menu-more"]',
            triggerBack       = '[data-trigger="wpiris-menu-back"]';

        $( document ).on( 'click', trigger, function ( e ) {
            e.preventDefault();
            $element.toggleClass( 'open' );
            $( trigger ).toggleClass( 'open' );
            $( 'body' ).toggleClass( 'menuOpen' );
            $( '.submenuActive' ).removeClass( 'submenuActive' );
        } );

        $( document ).on( 'click', triggerMore, function ( e ) {
            $( elementItem ).removeClass( 'submenuActive' );
            $( this ).parent().addClass( 'submenuActive' );
        } );

        $( document ).on( 'click', triggerBack, function ( e ) {
            $( this ).closest( elementItem ).removeClass( 'submenuActive' );
        } );

        $( document ).on( 'click', elementItemParent, function ( e ) {
            e.preventDefault();
            $( elementItem ).removeClass( 'submenuActive' );
            $( this ).parents( elementItem ).addClass( 'submenuActive' );
        } );
    }

    static scroll_header_large()
    {
        let last_scroll_top = 0;
        $(window).on('load scroll', function () {

            let scroll_top  = $(this).scrollTop();
            let $header     = $('.header--large');

            if($('.header--large').length) {
                if (scroll_top > 40) {
                    $header.removeClass('header--transparent');
                } else {
                    $header.addClass('header--transparent');
                }
            }
        });

    }
}